var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors } from '../../../defaultTheme';
const CardRowContainer = styled.div `
  display: flex;
  border-top: ${({ hasBorderTop }) => hasBorderTop ? `1px solid ${colors.lightGrey}` : ''};
  border-bottom: ${({ hasBorderBottom }) => hasBorderBottom ? `1px solid ${colors.lightGrey}` : ''};
`;
const CardRow = (_a) => {
    var { children, hasBorderTop, hasBorderBottom, className } = _a, props = __rest(_a, ["children", "hasBorderTop", "hasBorderBottom", "className"]);
    return (_jsx(CardRowContainer, Object.assign({}, props, { hasBorderTop: hasBorderTop, hasBorderBottom: hasBorderBottom, className: className }, { children: children })));
};
export default CardRow;
//# sourceMappingURL=CardRow.js.map